// Note: this feature was changed from original implementation to use BE provided endpoints for all resources and actions, it could be improved by holding state of profile and portfolio items in the service, simplifing some of the code below.

const CommentTemplatesService = class CommentTemplatesService {
  constructor ($http, $q, $timeout, Configuration, UserService) {
    'ngInject'

    this.$http = $http
    this.$q = $q
    this.$timeout = $timeout
    this.Configuration = Configuration
    this.UserService = UserService

    this.isLoading = false
    this.templates = []
  }

  async init () {
    this.isLoading = true
    await this.fetchTemplates()
      .then(result => {
        console.log('🚀 ~ CommentTemplatesComponent ~ this.fetchTemplates ~ result:', result)
        this.templates = result
      })
      .finally(() => {
        this.isLoading = false
      })
  }

  fetchTemplates () {
    return this.$http
      .get(`${this.Configuration.apiUrl}/experts/upsell_templates`)
      .then(response => {
        return response.data
      })
  }

  showTemplatesBtn () {
    return this.templates.length > 0
  }

  getTemplateList () {
    return this.templates
  }
}
export default CommentTemplatesService

